module.exports = __webpack_public_path__ + "img/ck.6d803365.svg";